<template>
  <el-card>
    <h1>{{ langData.report }}</h1>
    <!-- 搜索 -->
    <el-row class="search" :class="{ ar: isAr == 2 }">
      <el-col :xs="24" :lg="3">
        <span>{{ langData.selectWeek }}:</span>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-date-picker
          v-model="startDate"
          :format="getFormattedDate"
          type="week"
          :placeholder="langData.selectData"
          :picker-options="{ firstDayOfWeek: 1 }"
          style="width: 100%"
          @change="formatterTimes"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="1">
        <span>{{ langData.rid }}:</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-input style="width: 1005" v-model="search.rid"></el-input>
      </el-col>
      <el-col :xs="24" :lg="3">
        <span>{{ langData.activeHost }}:</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-select
          v-model="search.active"
          clearable
          class="selec"
          style="width: 100%"
        >
          <el-option :label="langData.all" :value="null"> </el-option>
          <el-option :label="langData.active" :value="1"> </el-option>
          <el-option :label="langData.inActive" :value="0"> </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="2">
        <span>{{ langData.country }}</span>
      </el-col>
      <el-col :xs="24" :lg="3">
        <el-select
          v-model="search.countryCode"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option :label="langData.all" :value="null"> </el-option>
          <el-option
            v-for="item in countryList"
            :key="item.countryCode"
            :label="item.country"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="2">
        <el-button type="primary" @click="query(1)">{{
          langData.search
        }}</el-button>
      </el-col>
      <el-col :xs="24" :lg="2">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          v-loading="dwnLoading"
          @click="download"
          >{{ langData.export }}</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-table
        :data="list"
        v-loading="loading"
        max-height="600"
        border
        :class="{ ar: isAr == 2 }"
      >
        <el-table-column
          :fixed="isMobile ? false : isAr == 2 ? false : 'left'"
          width="160"
          sortable
          prop="date"
          :label="langData.date"
        ></el-table-column>
        <el-table-column
          :fixed="isMobile ? false : isAr == 2 ? false : 'left'"
          width="180"
          sortable
          prop="countryCode"
          :label="langData.country"
        ></el-table-column>
        <el-table-column
          :fixed="isMobile ? false : isAr == 2 ? false : 'left'"
          width="160"
          sortable
          prop="name"
          :label="langData.name"
        >
          <template slot-scope="scope">
            <span class="notranslate">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :fixed="isMobile ? false : isAr == 2 ? false : 'left'"
          width="160"
          sortable
          prop="rid"
          :label="langData.rid"
        ></el-table-column>
        <!-- <el-table-column width="160"
          sortable
          
          prop="appraiseScore"
          :label="langData.appraiseScore"
        ></el-table-column> -->
        <el-table-column
          min-width="170"
          sortable
          prop="onlineDuration"
          :label="langData.onlineDuration"
          :formatter="formatDates"
        ></el-table-column>
        <el-table-column
          min-width="160"
          sortable
          prop="liveDuration"
          :label="langData.liveDuration"
          :formatter="formatDates"
        ></el-table-column>
        <el-table-column
          min-width="180"
          sortable
          prop="answerRate"
          :label="langData.answerRate"
        >
          <template slot-scope="scope">
            {{ `${(scope.row.answerRate * 100).toFixed(2)}%` }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="180"
          sortable
          prop="personalCallAvgTime"
          :label="langData.personalCallAvgTime"
          :formatter="formatDates"
        ></el-table-column>
        <el-table-column
          min-width="190"
          sortable
          prop="matchCallAvgTime"
          :label="langData.matchCallAvgTime"
          :formatter="formatDates"
        ></el-table-column>
        <el-table-column
          min-width="170"
          sortable
          prop="totalCallTime"
          :label="langData.matchCallCount"
          :formatter="formatDates"
        ></el-table-column>
        <el-table-column
          min-width="180"
          sortable
          prop="personalCallIncomeUSD"
          :label="langData.personalCallIncomeUSD"
        >
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.personalCallIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="160"
          sortable
          prop="matchCallIncomeUSD"
          :label="langData.matchCallIncomeUSD"
        >
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.matchCallIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="180"
          sortable
          prop="giftIncomeUSD"
          :label="langData.giftIncomeUSD"
        >
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.giftIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="160"
          sortable
          prop="totalIncomeUSD"
          :label="langData.totalIncomeUSD"
        >
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.totalIncomeUSD)}` }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="160"
          sortable
          prop="currDiamonds"
          :label="langData.currDiamonds"
        >
          <template slot-scope="scope">
            {{ `${Math.round(scope.row.currDiamonds * cr)}` }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination layout="prev, pager, next" :total="this.total" :page-size="this.pageSize"
      :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        :pager-count="isMobile ? 5 : 7">
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { getData, downloadDetail } from '@/api/report.js'
import { reportWeek } from '@/utils/lang.js'
import { getCountryList } from '@/api/operate.js'
import { downloadFile } from '@/utils/download.js'
import { cr } from '@/config'

export default {
  data() {
    return {
      cr: cr,
      loading: false,
      dwnLoading: false,
      list: [],
      startDate: new Date(),
      langData: {},
      isAr: parseInt(sessionStorage.getItem('lang')),
      isMobile: window.innerWidth <= 768,
      levelList: [
        {
          name: 'G0',
          value: 0,
        },
        {
          name: 'G1',
          value: 1,
        },
        {
          name: 'G2',
          value: 2,
        },
        {
          name: 'G3',
          value: 3,
        },
      ],
      agentType: [
        JSON.parse(sessionStorage.getItem('loginData')).agentType[0].value,
      ],
      search: {
        rid: null,
        active: null,
        countryCode: null,
        startDate: null,
        endDate: null,
      },
      countryList: [],
      agentName: '',
      agentTypes: JSON.parse(sessionStorage.getItem('loginData')).agentType,
      currentPage: 1,
      total: 0,
      pageSize: 100,
    }
  },
  created() {
    if (sessionStorage.getItem('lang')) {
      this.langData = reportWeek[parseInt(sessionStorage.getItem('lang'))]
    } else {
      window.sessionStorage.setItem('lang', '1')
      this.langData = reportWeek[1]
    }
    this.getCountryCode()
    this.setDefaultThisWeek()
    this.query()
    
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.lang': function (val) {
      this.langData = reportWeek[val]
      this.isAr = val
    },
  },
  computed: {
    getFormattedDate() {
      // 如果 startDate 或 search.startDate 或 search.endDate 为空，则使用默认格式
      if (!this.search.startDate || !this.search.endDate) {
        return 'yyyy WeekWW(--)' // 默认显示一个占位符
      }

      // 否则返回具体的日期格式
      return `yyyy WeekWW(${this.search.startDate
        .slice(-4)
        .replace('-', '/')}-${this.search.endDate.slice(-4).replace('-', '/')})`
    },
  },

  methods: {
    handleCurrentChange(page) {
      this.currentPage = page
      this.query()
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    download() {
      this.dwnLoading = true
      downloadDetail(
        {
          ...this.search,
          lang: ['en', 'zh', 'ar', 'es'][this.isAr || 0],
          page: -1
        },
        2
      )
        .then((response) => {
          this.dwnLoading = false
          this.$message.success('开始下载')
          downloadFile(response.data, this.langData.report)
        })
        .finally(() => {
          this.dwnLoading = false
        })
    },
    formatDates(row, column) {
      if (!row[column.property]) return '0h:0m:0s'
      const time = row[column.property]
      const hours = Math.floor(time / 3600)
      const minutes = Math.floor((time % 3600) / 60)
      const seconds = (time % 60).toFixed(0)
      return `${hours}h:${minutes}m:${seconds}s`
    },
    formatterTimes(date) {
      console.log(date)
      function formatDate(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以要加1
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      // 调整日期往前一天
      const previousDate = new Date(date)
      previousDate.setDate(date.getDate() - 1) // 往前推一天

      // 获取调整后的日期的 yyyy-MM-dd
      const currentFormattedDate = formatDate(previousDate)

      // 计算7天后的日期
      const sevenDaysLater = new Date(previousDate)
      sevenDaysLater.setDate(previousDate.getDate() + 6)

      // 获取7天后的日期的 yyyy-MM-dd
      const sevenDaysLaterFormattedDate = formatDate(sevenDaysLater)

      // 更新search对象的startDate和endDate
      this.search.startDate = currentFormattedDate
      this.search.endDate = sevenDaysLaterFormattedDate
    },
    formatDate(row, column) {
      if (!row[column.property]) return ''
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    handleClose() {
      this.dialogVisible = false
      this.agentName = ''
      this.agentType = [this.agentTypes[0].value]
      this.agentTypes = JSON.parse(
        sessionStorage.getItem('loginData')
      ).agentType
    },
    Creates() {
      if (JSON.parse(sessionStorage.getItem('loginData')).canCreateSon == 1) {
        return true
      }
      return false
    },
    // 获取列表
    async query(page) {
      if (page) {
        this.currentPage = page
      }
      if (!this.search.startDate) {
        return this.$message({
          message: this.langData.selectData,
          center: true,
          type: 'error',
        })
      }
      this.loading = true
      const { data: res } = await getData({
        ...this.search,
        countryCode: this.search.countryCode || null,
        page: this.currentPage,
      })
      this.loading = false
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })
      this.list = res.data.data
      this.total = res.data.total
    },

    // 获取创建
    async create() {
      let agentType = this.agentType.join()
      const { data: res } = await getAgencyregister({
        agentId: JSON.parse(sessionStorage.getItem('loginData')).agentId,
        agentType: agentType,
        agentName: this.agentName,
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })

      this.handleClose()
      this.query()
    },

    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await getCountryList()
      this.countryList = res.data.countryList
    },
    // 设置默认本周二的值
    setDefaultThisWeek() {
      const today = new Date()
      const dayOfWeek = today.getDay()
      const startOfThisWeek = new Date(today)
      startOfThisWeek.setDate(today.getDate() - dayOfWeek + 2) // 设置为本周二
      this.startDate = startOfThisWeek
      this.formatterTimes(startOfThisWeek)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>